import { Accordion, AccordionHeader } from '@material-tailwind/react';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentProductRow } from '../components/PaymentProductRow';
import { GetAllOrder } from '../services/ApiServices/OrderService';
import { formatPrice } from '../services/formatPrice';

function AdminOrders({ setLoading, filterStatus }: any) {
    const [orders, setOrders] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const [open, setOpen] = useState(1);

    const handleOpen = (value: number) => setOpen(open === value ? 0 : value);

    const fetchOrders = async () => {
        setLoading(true);
        try {
            const userInfos = await GetAllOrder();
            setLoading(false);
            console.log(userInfos)
            setOrders(userInfos);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchOrders();
    }, []);

    const filteredOrders = filterStatus ? orders.filter((order: any) => order.status === filterStatus) : orders;
    console.log(filteredOrders)

    return (
        <div className="about-container w-full my-5">
            <div className="about-header">
                <h2 className="text-3xl text-center font-semibold mb-4">
                    {filterStatus ? "Đơn hàng đã thanh toán" : "Đơn hàng"}
                </h2>
                <div className="underline"></div>
                <div className="text-red-500">{errorMessage}</div>
                {filteredOrders.map((order: any, index) => (
                    <Accordion
                    placeholder={""}
                        open={open === index + 1}
                        className="mb-2 rounded-lg border border-blue-gray-100 p-5"
                        onClick={() => navigate(`/dashboard/order-detail/${order.id}`)}
                        key={order.id}
                    >
                        <div className="flex justify-between">
                            <div className="text-2xl font-semibold">Đơn hàng của {order.userInfo.receiverName}</div>
                            <div className="text-lg font-semibold">{moment(order.orderDate).format("DD/MM/YYYY")}</div>
                        </div>
                        <AccordionHeader placeholder={""}
                            onClick={() => handleOpen(index + 1)}
                            className="border-b-0 transition-colors"
                        >
                            <div className="w-full">
                                {order.orderProducts.length > 0 && order.orderProducts.map((product: any) => (
                                    <PaymentProductRow product={product} key={product.id} />
                                ))}
                            </div>
                        </AccordionHeader>
                        <div className="flex justify-start gap-5">
                            <div className="text-xl font-semibold">Tổng tiền:</div>
                            <div className="text-red-500 text-lg">{formatPrice(order.totalPrice)}</div>
                        </div>
                        <div className="flex justify-start gap-5">
                            <div className="text-xl font-semibold">Trạng thái:</div>
                            <div>{order.status}</div>
                        </div>
                        <div className="flex justify-start gap-5">
                            <div className="text-xl font-semibold">Phương thức thanh toán:</div>
                            <div>{order.payments && order.payments[0].description}</div>
                        </div>
                    </Accordion>
                ))}
            </div>
        </div>
    );
}

export default AdminOrders;
